export default "/images/vendor/flag-icon-css/flags/1x1/ht.svg?663996cf665e8ab764d5df3d49b4b73d";